<script setup lang="ts">
import type { ParsedContent } from '@nuxt/content'
import { joinParts, parenthesize, titleCase } from './util'
import { ageText, classText, type CharacterData } from './familytree/familytree'

const props = defineProps<{
  item: CharacterData | ParsedContent
  condensed?: boolean
}>()

const char = props.item as CharacterData

const subtitle = computed(() => {
  const age = ageText(char)
  const cls = classText(char, props.condensed);
  if (!props.condensed) {
    // TODO: support multiclassing
    return joinParts(
      ' ',
      titleCase(char.subrace),
      titleCase(char.race),
      cls,
      parenthesize(joinParts(', ', titleCase(char.background), char.alignment?.toUpperCase(), age)),
    )
  } else {
    const core = joinParts(' ', char.subrace?.toLowerCase(), char.race?.toLowerCase(), cls)
    return joinParts(', ', core, char.alignment?.toUpperCase(), age)
  }
})
</script>

<template>
  <p class="subtitle subtitle--character">{{ subtitle }}</p>
</template>

<style scoped lang="postcss"></style>
